import { useFetchAutocompleteEntries } from "services/email";
import { useEffect } from "react";
import { AutocompleteEntry } from "protogen/email_service_pb";

interface Props {
  familyRef?: string;
  lazyLoadToggle?: boolean;
}
type Result = {
  autocompleteEntries: AutocompleteEntry[];
  loading: boolean;
};
export default ({ familyRef, lazyLoadToggle }: Props): Result => {
  const { request, data, loading } = useFetchAutocompleteEntries();
  useEffect(() => {
    if (lazyLoadToggle !== undefined && !lazyLoadToggle) {
      return;
    }
    request({ familyRef: familyRef || "" });
  }, [familyRef, lazyLoadToggle]);
  return {
    autocompleteEntries: data?.autocompleteEntries || [],
    loading,
  };
};
